import { Link } from 'react-router-dom'
import PageHeader from './PageHeader.jsx'

export default function ForbiddenPage({
  title = '권한이 없습니다.',
  description = '이 기능에 접근할 수 없습니다.',
  to = '/inventory',
  actionLabel = '재고 목록으로',
}) {
  return (
    <div className="page">
      <PageHeader title={title} description={description} />
      <Link to={to} className="btn btn--primary btn--touch">
        {actionLabel}
      </Link>
    </div>
  )
}
